import React, { useState, useContext, useEffect } from "react";

// Material-UI
import { makeStyles, alpha } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";
import MinimizeIcon from "@material-ui/icons/Minimize";
import AspectRatioIcon from "@material-ui/icons/AspectRatio";

// Internal
import ChatOverlay from "..";
import Device from "sccDevice";
import Images from "sccImage";
import Chat from "sccChat";
import CustomTooltip from "@Components/CustomTooltip";
import { ModuleWrapperContext } from "@Components/ModuleWrapper/ModuleWrapperContext";
import Message from "sccMessage";
import Profile from "sccProfile";
import Language from "sccLanguage";
import { Badge } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  DataDisplayHeader: {
    background: theme.palette.colors.gray.main,
    boxShadow: "none",
    color: theme.palette.colors.blue.dark,
  },

  DataDisplayHeaderToolbar: {
    minHeight: 30,
    padding: "1px 4px",
  },

  DataDisplayHeaderAvatar: {
    width: 30,
    height: 30,
    borderRadius: "inherit",
    backgroundColor: "transparent",
    justifyContent: "flex-start",
  },

  title: {
    flexGrow: 1,
    fontSize: 18,
    paddingLeft: 10,
    display: "flex",
    alignItems: "center",
  },

  DataDisplayHeaderImage: {
    maxHeight: "100%",
    maxWidth: "100%",
  },

  DataDisplayHeaderIcon: {
    color: alpha(theme.palette.colors.black.main, 0.25),
    fontSize: "1.2rem",
  },

  DataDisplayHeaderButton: {
    minWidth: 30,
    width: 30,
    height: 30,
    borderRadius: 0,
    "&:hover": {
      backgroundColor: theme.palette.colors.gray.dark,
      "& $DataDisplayHeaderIcon": {
        color: theme.palette.colors.blue.dark,
      },
    },
  },
}));

export default function ChatHeader(props) {
  const minimize = props.minimize;

  const classes = useStyles();

  const obj = props.device.id ? props.device : Object.values(props.device)[0];
  
  const[unreadMessages, setUnreadMessages] = useState();
  useEffect(() => {
    setTimeout(() => {
      Chat.loadMessageChat(obj.id)
      setUnreadMessages(Chat.hasUnreadMessages[obj.id])
    }, 1000)
    if(Chat.hasUnreadMessages[obj.id] == null){
      setUnreadMessages(unreadMessages)
    }
    else{
      setUnreadMessages(!unreadMessages)
    }
  }, [Chat.hasUnreadMessages[obj.id]]);

  const handleClose = () => {
    ChatOverlay.hideChatWindow(obj);
    if(Chat.hasUnreadMessages[obj.id] == true) {
      return Chat.hasUnreadMessages[obj.id] = null; 
    }
  };

  const showChat = () => {
    ChatOverlay.maximizeChatWindow(obj);
    if(Chat.hasUnreadMessages[obj.id] == true) {
      return Chat.hasUnreadMessages[obj.id] = null; 
    }
  };
  const hideChat = () => {
    ChatOverlay.minimizeChatWindow(obj);
    if(Chat.hasUnreadMessages[obj.id] == true) {
      return Chat.hasUnreadMessages[obj.id] = null; 
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.DataDisplayHeader}>
        <Toolbar className={classes.DataDisplayHeaderToolbar}>
          <Avatar className={classes.DataDisplayHeaderAvatar}>
            <img
              className={classes.DataDisplayHeaderImage}
              alt={Images.get(Device.getDeviceType(obj.type_id).image_id).name}
              src={Images.getImageSource(
                Device.getDeviceType(obj.type_id).image_id
              )}
            />
          </Avatar>
          <Badge
                //color="secondary"
                //badgeContent={unreadMessages}
                //max={9999}
              ></Badge>
          <Typography variant="h6" className={classes.title}>
            {obj.name}
          </Typography>
          <CustomTooltip
            title={
              minimize
                ? Language.translate("Maximize")
                : Language.translate("Minimize")
            }
            arrow
            placement="top"
          >
            {minimize ? (
              <IconButton
                size="medium"
                color="inherit"
                onClick={showChat}
                className={classes.DataDisplayHeaderButton}
              >
                <AspectRatioIcon className={classes.DataDisplayHeaderIcon} />
              </IconButton>
            ) : (
              <IconButton
                size="medium"
                color="inherit"
                onClick={hideChat}
                className={classes.DataDisplayHeaderButton}
              >
                <MinimizeIcon className={classes.DataDisplayHeaderIcon} />
              </IconButton>
            )}
          </CustomTooltip>
          <CustomTooltip
            title={Language.translate("Close")}
            arrow
            placement="top"
          >
            <IconButton
              size="medium"
              color="inherit"
              onClick={handleClose}
              className={classes.DataDisplayHeaderButton}
            >
              <CloseIcon className={classes.DataDisplayHeaderIcon} />
            </IconButton>
          </CustomTooltip>
        </Toolbar>
      </AppBar>
    </div>
  );
}
